<template>
  <div class="fit-content">
    <div>
      <DataTableDeCrud
        :items="piscofinss"
        :headers="headers"
        :rotina-id="ID_TELA_DE_PISCOFINS"
        :configurar="false"
        :loading="loading"
        :busca-param="buscaParam"
        @create="() => abrirDialogCriarPISCOFINS()"
        @update="(indice) => abrirDialogEditarPISCOFINS(indice)"
        @delete="(indice) => openDialogDeletePISCOFINS(indice)"
      >
        <template #[`item.percentualPISEntrada`]="{ item }">
          {{ formatNumber(item.percentualPISEntrada) }}
        </template>

        <template #[`item.percentualCOFINSEntrada`]="{ item }">
          {{ formatNumber(item.percentualCOFINSEntrada) }}
        </template>

        <template #[`item.percentualPISSaida`]="{ item }">
          {{ formatNumber(item.percentualPISSaida) }}
        </template>

        <template #[`item.percentualCOFINSSaida`]="{ item }">
          {{ formatNumber(item.percentualCOFINSSaida) }}
        </template>
      </DataTableDeCrud>
      <DialogDeEdicaoDePISCOFINS
        :operacao="operacao"
        :show-dialog.sync="showDialogParam"
        :pis-cofins-param="piscofinsParam"
        :itens="itensParam"
        @confirmado="atualizarPISCOFINS"
      />
      <SnackbarMessage
        :show-snack.sync="snackbar.showSnackParam"
        :snack-text="snackbar.snackTextParam"
        :snack-type="snackbar.snackTypeParam"
      />

      <v-dialog v-model="dialogDeletePISCOFINS" persistent max-width="380">
        <v-card>
          <v-card-title class="headline">Excluir</v-card-title>
          <v-card-text refs="piscofinsDelete">
            Tem certeza que deseja excluir o PISCOFINS <b> {{ piscofinsDelete.descricao }} </b>?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialogDeletePISCOFINS = false">Cancelar</v-btn>
            <v-btn color="green darken-1" text @click="removerPISCOFINS">Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import PISCOFINSService from '@/services/pisCofins/pisCofins'
import SnackbarMessage from '@/components/SnackbarMessage'
import DialogDeEdicaoDePISCOFINS from '@/components/piscofins/DialogDeEdicaoDePISCOFINS'
import DataTableDeCrud from '@/components/DataTableDeCrud'
import SnackBar from '@/models/components/snackbar'
import PISCOFINS from '@/models/piscofins'
import LeiService from '@/services/lei/lei'
import NCMService from '@/services/ncm/ncm'
import NaturezaService from '@/services/natureza/natureza'
import CSTService from '@/services/cst/cst'
import { ID_TELA_DE_PISCOFINS } from '@/common/constants'
import { formatNumber } from '@/shareds/formatacoes'

export default {
  components: {
    SnackbarMessage,
    DataTableDeCrud,
    DialogDeEdicaoDePISCOFINS
  },

  props: ['buscaParam'],

  data: () => ({
    name: 'TelaDePISCOFINS',
    headers: [
      { text: 'NCM', value: 'ncm.codigo' },
      { text: 'Descrição', value: 'descricao' },
      { text: 'Observação', value: 'observacao' },
      { text: 'Lei', value: 'lei.nome' },
      { text: 'PIS Entrada', value: 'percentualPISEntrada' },
      { text: 'COFINS Entrada', value: 'percentualCOFINSEntrada' },
      { text: 'CST Entrada', value: 'cstEntrada.codigo' },
      { text: 'Natureza Entrada', value: 'naturezaEntrada.codigo' },
      { text: 'PIS Saída', value: 'percentualPISSaida' },
      { text: 'COFINS Saída', value: 'percentualCOFINSSaida' },
      { text: 'CST Saída', value: 'cstSaida.codigo' },
      { text: 'Natureza Saída', value: 'naturezaSaida.codigo' }
    ],
    piscofinss: [],
    loading: false,
    validForm: false,
    dialog: false,
    operacao: '',
    showDialogParam: false,
    piscofinsParam: new PISCOFINS(),
    itensParam: {},
    snackbar: new SnackBar(),
    dialogDeletePISCOFINS: false,
    piscofinsDelete: new PISCOFINS(),
    indicePISCOFINSDelete: 0,
    itensNCM: [],
    itensLei: [],
    itensNatureza: [],
    itensCST: [],
    ID_TELA_DE_PISCOFINS: ID_TELA_DE_PISCOFINS,
    formatNumber: formatNumber
  }),

  created() {
    this.initialize()
  },

  methods: {
    initialize() {
      try {
        if (this.$route.query.id) {
          PISCOFINSService.getById(this.$route.query.id).then((response) =>
            this.piscofinss.push(response)
          )
        } else {
          this.loadPISCOFINSs()
        }

        this.loadNCMs()
        this.loadLeis()
        this.loadNaturezas()
        this.loadCSTs()
      } catch (error) {
        this.snackbar.snackTextParam = 'Não foi possível encontrar PISCOFINS cadastrados.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    async loadPISCOFINSs() {
      this.loading = true
      const response = await PISCOFINSService.getAll()
      this.piscofinss = response.map((item) => ({
        ...item
      }))
      this.loading = false
    },

    async loadLeis() {
      const response = await LeiService.getAll()
      this.itensLei = response.map((item) => ({
        text: item.codigo + ' - ' + item.nome,
        value: item.id
      }))
    },

    async loadNaturezas() {
      const responseEntrada = await NaturezaService.buscarTipoMovimentoEntrada()
      this.itensNaturezaEntrada = responseEntrada
        .filter((natureza) => natureza.tipoMovimento === 'ENTRADA')
        .map((item) => ({
          text: item.codigo + ' - ' + item.descricao,
          value: item.id
        }))

      const responseSaida = await NaturezaService.buscarTipoMovimentoSaida()
      this.itensNaturezaSaida = responseSaida
        .filter((natureza) => natureza.tipoMovimento === 'SAIDA')
        .map((item) => ({
          text: item.codigo + ' - ' + item.descricao,
          value: item.id
        }))
    },

    async loadNCMs() {
      const response = await NCMService.getAll()
      this.itensNCM = response.map((item) => ({
        text: item.codigo + ' - ' + item.descricao,
        value: item.id
      }))
    },

    async loadCSTs() {
      const response = await CSTService.getAllPisCofins()
      this.itensCST = response.map((item) => ({
        text: item.codigo + ' - ' + item.descricao,
        value: item.id
      }))
    },

    atualizarPISCOFINS(piscofins) {
      if (!piscofins) return

      const indice = this.piscofinss.findIndex(
        (piscofinsExistente) => piscofinsExistente.id === piscofins.id
      )

      if (indice === -1) {
        this.piscofinss.push(piscofins)
        this.snackbar.snackTextParam = 'PISCOFINS criado com sucesso.'
      } else {
        this.piscofinss.splice(indice, 1, piscofins)
        this.snackbar.snackTextParam = 'PISCOFINS atualizado com sucesso.'
      }

      this.snackbar.snackTypeParam = 'sucess'
      this.snackbar.showSnackParam = true
    },

    openDialogDeletePISCOFINS(indice) {
      this.piscofinsDelete = this.piscofinss[indice]
      if (!this.piscofinsDelete.id) return

      this.indicePISCOFINSDelete = indice
      this.dialogDeletePISCOFINS = true
    },

    async removerPISCOFINS() {
      try {
        await PISCOFINSService.deleteById(this.piscofinsDelete.id)
        this.snackbar.snackTextParam = 'PISCOFINS removido com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
        this.piscofinss.splice(this.indicePISCOFINSDelete, 1)
      } catch (error) {
        this.snackbar.snackTextParam = 'Não foi possível excluir o PISCOFINS.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
      this.dialogDeletePISCOFINS = false
    },

    abrirDialogCriarPISCOFINS() {
      this.operacao = 'adicionar'
      this.itensParam = {
        ncm: this.itensNCM,
        lei: this.itensLei,
        naturezaEntrada: this.itensNaturezaEntrada,
        naturezaSaida: this.itensNaturezaSaida,
        cst: this.itensCST
      }
      this.piscofinsParam = new PISCOFINS()
      this.showDialogParam = true
    },

    abrirDialogEditarPISCOFINS(indice) {
      this.operacao = 'editar'
      this.itensParam = {
        ncm: this.itensNCM,
        lei: this.itensLei,
        naturezaEntrada: this.itensNaturezaEntrada,
        naturezaSaida: this.itensNaturezaSaida,
        cst: this.itensCST
      }
      this.piscofinsParam = { ...this.piscofinss[indice] }
      this.showDialogParam = true
    }
  }
}
</script>
<style scoped>
.flex-toolbar-parameters {
  flex: 0 1 auto;
}

::v-deep .v-data-table-header {
  vertical-align: top;
}
</style>
